import { useEffect, useState } from 'react';
import { resolveApiUrl } from '../services/api';

interface Props {
  src: string;
  alt: string;
  className?: string;
  placeholderSrc?: string;
  onFinalError?: () => void;
}

export default function ProductImage({ src, alt, className, placeholderSrc = '/api/assets/product-placeholder.svg', onFinalError }: Props) {
  const resolvedSrc = resolveApiUrl(src);
  const resolvedPlaceholder = resolveApiUrl(placeholderSrc);
  const [currentSrc, setCurrentSrc] = useState(resolvedSrc);

  useEffect(() => {
    setCurrentSrc(resolvedSrc);
  }, [resolvedSrc]);

  return (
    <img
      src={currentSrc}
      alt={alt}
      className={className}
      loading="lazy"
      onError={event => {
        const failedUrl = event.currentTarget.currentSrc || event.currentTarget.src || currentSrc;

        if (currentSrc !== resolvedPlaceholder) {
          console.warn('[ProductImage] Falha ao carregar imagem, usando placeholder:', failedUrl);
          setCurrentSrc(resolvedPlaceholder);
          return;
        }

        console.error('[ProductImage] Falha ao carregar placeholder:', failedUrl);
        onFinalError?.();
      }}
    />
  );
}
